/* pdp-commerce.js – Besitzer: Agent «Commerce» (siehe PDP-ELITE-SPEC.md)
   Haengt sich ohne Aenderung an theme.js ein:
   - Variante/Menge: liest [data-variant-id] und [data-qty-input] (theme.js pflegt beide) nach dem jeweiligen Ereignis.
   - Warenkorb: theme.js sendet keine Ereignisse; die Seite hoert deshalb auf den Austausch des Drawer-Inhalts
     ([data-cart-drawer-content]) und liest danach einmal /cart.js (kein Polling).
   - Cross-Sell: /cart/add.js mit mehreren Artikeln, Drawer wie theme.js aktualisieren und per Klick auf [data-cart-open] oeffnen. */
(() => {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const routes = (window.theme && window.theme.routes) || {};

  /* Geld wie theme.js / page-product.js (window.theme.moneyFormat, Schweizer Format) */
  const money = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    const [int, dec] = (cents / 100).toFixed(2).split('.');
    const apos = int.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return fmt
      .replace(/{{\s*amount\s*}}/, `${apos}.${dec}`)
      .replace(/{{\s*amount_no_decimals\s*}}/, apos)
      .replace(/{{\s*amount_with_comma_separator\s*}}/, `${int},${dec}`)
      .replace(/{{\s*amount_with_apostrophe_separator\s*}}/, `${apos}.${dec}`);
  };

  const fill = (tpl, map) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));
  const readJSON = (el) => {
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  };

  /* ---------- gemeinsamer Zustand pro Produktbereich ---------- */
  function initCommerce(root) {
    if (!root || root.dataset.pcReady) return;
    const extras = $('[data-pc-extras]', root);
    const cross = $('[data-pc-cross]', root);
    if (!extras && !cross) return;
    root.dataset.pcReady = '1';

    const variants = readJSON($('[data-variants]', root)) || [];
    const idInput = $('[data-variant-id]', root);
    const qtyInput = $('[data-qty-input]', root);
    const cfg = readJSON($('[data-pc-config]', root)) || { t: {} };
    const crossCfg = readJSON($('[data-pc-cross-config]', root)) || { t: {} };
    // Der Liquid-Filter «t» maskiert Anfuehrungszeichen (l&#39;instant) – fuer textContent zurueckwandeln.
    const decoder = document.createElement('textarea');
    const decode = (obj) => {
      const out = {};
      Object.keys(obj || {}).forEach((k) => {
        decoder.innerHTML = String(obj[k]);
        out[k] = decoder.value;
      });
      return out;
    };
    const T = decode(cfg.t);
    const CT = decode(crossCfg.t);

    const state = {
      cartShip: null,        // Summe versandpflichtiger Artikel im Warenkorb (Rappen); null = Wert aus dem HTML
      cartQty: {},           // variantId -> Menge im Warenkorb
      lastAdded: null,       // { id, qty }: Auswahl, die schon im Warenkorb liegt (nicht doppelt zaehlen)
      pendingAdd: null,
    };

    const currentVariant = () => {
      const id = idInput ? String(idInput.value) : '';
      return variants.find((v) => String(v.id) === id) || variants[0] || null;
    };
    const currentQty = () => {
      const n = parseInt(qtyInput ? qtyInput.value : '1', 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    };

    /* ---------- 1. Preis pro Portion ---------- */
    const portionEl = $('[data-pc-portion]', root);
    function renderPortion(v) {
      if (!portionEl || !v) return;
      const unit = portionEl.dataset.unit;
      const kind = portionEl.dataset.kind;
      let nMin = parseInt(portionEl.dataset.min, 10) || 0;
      let nMax = parseInt(portionEl.dataset.max, 10) || 0;
      if (kind === 'variant') {
        nMin = parseInt(v.option1, 10) || parseInt(v.title, 10) || 0;
        nMax = nMin;
      }
      if (!(nMin > 1 || kind === 'range')) { portionEl.hidden = true; return; }
      let amount;
      let approx = true;
      if (kind === 'range') {
        amount = fill(T.range, { low: money(Math.round(v.price / nMax)), high: money(Math.round(v.price / nMin)) });
      } else {
        amount = money(Math.round(v.price / nMin));
        if (v.price % nMin === 0 && kind !== 'ca' && kind !== 'upto') approx = false;
      }
      let tpl = T.linePortion;
      if (unit === 'piece') tpl = approx ? T.linePieceApprox : T.linePiece;
      else if (unit === 'bottle') tpl = T.lineBottle;
      const main = $('[data-pc-portion-main]', portionEl);
      if (main) main.textContent = fill(tpl, { amount });

      let basis = '';
      if (kind === 'range') basis = fill(T.basisRange, { min: nMin, max: nMax });
      else if (kind === 'ca') basis = fill(T.basisAbout, { n: nMin });
      else if (kind === 'upto') basis = fill(T.basisUpto, { n: nMin });
      else if (kind === 'exact' && unit === 'portion') basis = fill(T.basisExact, { n: nMin });
      const basisEl = $('[data-pc-portion-basis]', portionEl);
      if (basisEl) basisEl.textContent = basis;
      portionEl.hidden = false;
    }

    /* ---------- 3. Versand-Fortschritt ---------- */
    const shipEl = $('[data-pc-ship]', root);
    function renderShip(v) {
      if (!shipEl || !v) return;
      const threshold = parseInt(shipEl.dataset.threshold, 10) || 0;
      if (!threshold) return;
      const cartShip = state.cartShip == null ? parseInt(shipEl.dataset.cart, 10) || 0 : state.cartShip;
      const qty = currentQty();
      const alreadyInCart = state.lastAdded && String(state.lastAdded.id) === String(v.id) && state.lastAdded.qty === qty;
      const pending = v.available && v.requires_shipping !== false && !alreadyInCart ? v.price * qty : 0;
      const total = cartShip + pending;
      const remaining = threshold - total;
      const progress = Math.max(0, Math.min(100, Math.floor((total * 100) / threshold)));
      const done = remaining <= 0;
      const msg = $('[data-pc-ship-msg]', shipEl);
      const next = done ? T.shipDone : fill(T.shipRemaining, { amount: money(remaining) });
      if (msg && msg.dataset.last !== next) {
        // Nur der «Noch …»-Text enthaelt Markup (<strong> um den Betrag, aus unserer Uebersetzung; der Betrag ist eine formatierte Zahl).
        const probe = document.createElement('span');
        if (done) probe.textContent = next; else probe.innerHTML = next;
        // Beim ersten Durchlauf steht derselbe Text schon im HTML: nicht neu schreiben (kein Vorlesen durch aria-live)
        if (msg.textContent.trim() !== probe.textContent.trim()) {
          if (done) msg.textContent = next;
          else msg.innerHTML = next;
        }
        msg.dataset.last = next;
      }
      shipEl.classList.toggle('is-done', done);
      shipEl.style.setProperty('--pc-p', `${progress}%`);
      const bar = $('[data-pc-ship-bar]', shipEl);
      if (bar) bar.setAttribute('aria-valuenow', String(progress));
    }

    /* ---------- 4. Cross-Sell: Summe und Button ---------- */
    const items = cross ? $$('[data-pc-item]', cross) : [];
    const addBtn = cross ? $('[data-pc-add]', cross) : null;
    const addLabel = cross ? $('[data-pc-add-label]', cross) : null;
    const sumEl = cross ? $('[data-pc-sum]', cross) : null;
    const errEl = cross ? $('[data-pc-error]', cross) : null;
    let busy = false;

    function renderCross(v) {
      if (!cross || !addBtn || !v) return;
      const chosen = items.filter((cb) => cb.checked);
      const mainOk = Boolean(v.available);
      const qty = currentQty();
      const extraSum = chosen.reduce((s, cb) => s + (parseInt(cb.dataset.price, 10) || 0), 0);
      const total = (mainOk ? v.price * qty : 0) + extraSum;
      items.forEach((cb) => {
        const card = cb.closest('[data-pc-card]');
        if (card) card.classList.toggle('is-selected', cb.checked);
      });
      if (busy) return;
      if (!chosen.length) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = CT.btnEmpty;
        if (sumEl) sumEl.textContent = CT.sumNone;
        return;
      }
      addBtn.disabled = false;
      const parts = [];
      if (mainOk) parts.push(qty > 1 ? fill(CT.thisQty, { qty }) : CT.this);
      parts.push(chosen.length === 1 ? CT.extraOne : fill(CT.extraOther, { n: chosen.length }));
      const totalText = money(total);
      if (addLabel) addLabel.textContent = `${mainOk ? CT.btnAll : CT.btnSelection} · ${totalText}`;
      if (sumEl) sumEl.textContent = fill(CT.sum, { total: totalText, parts: parts.join(' + ') });
    }

    const renderAll = () => {
      const v = currentVariant();
      renderPortion(v);
      renderShip(v);
      renderCross(v);
    };

    /* ---------- Ereignisse: Variante, Menge ---------- */
    // Delegation am document laeuft nach den Handlern von theme.js (die haengen direkt an den Elementen).
    const later = () => window.setTimeout(renderAll, 0);
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (t instanceof Element && root.contains(t) && t.matches('.option__input, [data-qty-input]')) later();
    });
    document.addEventListener('click', (e) => {
      const t = e.target;
      if (t instanceof Element && root.contains(t) && t.closest('[data-qty-minus], [data-qty-plus]')) later();
    });
    if (qtyInput) qtyInput.addEventListener('input', later);

    /* ---------- Warenkorb beobachten (Versand-Fortschritt) ---------- */
    let cartTimer = null;
    let cartInflight = false;
    async function readCart() {
      if (cartInflight) return;
      cartInflight = true;
      try {
        const res = await fetch(`${routes.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        if (!res.ok) return; // z. B. 429: Anzeige bleibt wie sie ist
        const data = await res.json();
        let ship = 0;
        const qtyMap = {};
        (data.items || []).forEach((it) => {
          if (it.requires_shipping) ship += it.final_line_price;
          qtyMap[it.variant_id] = (qtyMap[it.variant_id] || 0) + it.quantity;
        });
        state.cartShip = ship;
        state.cartQty = qtyMap;
        if (state.pendingAdd) {
          if ((qtyMap[state.pendingAdd.id] || 0) >= state.pendingAdd.qty) state.lastAdded = state.pendingAdd;
          state.pendingAdd = null;
        }
        if (state.lastAdded && (qtyMap[state.lastAdded.id] || 0) < state.lastAdded.qty) state.lastAdded = null;
        renderAll();
      } catch (e) { /* Netzfehler: nichts aendern */ } finally { cartInflight = false; }
    }
    const scheduleCartRead = () => {
      window.clearTimeout(cartTimer);
      cartTimer = window.setTimeout(readCart, 250);
    };

    const drawerContent = $('[data-cart-drawer-content]');
    if (drawerContent && 'MutationObserver' in window) {
      new MutationObserver(scheduleCartRead).observe(drawerContent, { childList: true });
    }
    // Normaler Kaufen-Button: Auswahl merken (theme.js macht den Rest), damit sie nach dem Hinzufuegen nicht doppelt zaehlt
    document.addEventListener('submit', (e) => {
      const f = e.target;
      if (!(f instanceof HTMLFormElement) || !f.matches('[data-product-form]') || !root.contains(f)) return;
      const v = currentVariant();
      if (!v) return;
      state.pendingAdd = { id: v.id, qty: currentQty() };
      window.setTimeout(() => { state.pendingAdd = null; }, 10000);
    }, true);
    // Zurueck-Navigation aus dem Cache: Warenkorb kann sich geaendert haben
    window.addEventListener('pageshow', (e) => { if (e.persisted) scheduleCartRead(); });

    /* ---------- Cross-Sell: Auswahl ---------- */
    if (cross) {
      cross.addEventListener('change', (e) => {
        if (e.target instanceof Element && e.target.matches('[data-pc-item]')) {
          hideError();
          renderCross(currentVariant());
        }
      });
      // Ganze Karte klickbar (Link und Schalter behalten ihr eigenes Verhalten)
      cross.addEventListener('click', (e) => {
        const t = e.target;
        if (!(t instanceof Element) || t.closest('a, label, input, button')) return;
        const card = t.closest('[data-pc-card]');
        const cb = card && $('[data-pc-item]', card);
        if (cb) { cb.checked = !cb.checked; cb.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if (addBtn) addBtn.addEventListener('click', addAll);
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    function hideError() {
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    }

    // Drawer-Inhalt austauschen wie theme.js (cart.refresh), dann oeffnen wie der Kaufen-Button
    async function refreshDrawer() {
      const res = await fetch(`${routes.root || '/'}?sections=cart-drawer`);
      if (!res.ok) throw new Error('drawer');
      const json = await res.json();
      const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
      const next = $('[data-cart-drawer]', doc);
      const drawer = $('[data-cart-drawer]');
      const target = drawer && $('[data-cart-drawer-content]', drawer);
      const source = next && $('[data-cart-drawer-content]', next);
      if (!target || !source) return false;
      target.innerHTML = source.innerHTML;
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = next.dataset.itemCount;
        el.classList.toggle('is-empty', Number(next.dataset.itemCount) === 0);
      });
      return true;
    }
    function openDrawer() {
      const opener = $('[data-cart-open]');
      if (opener) opener.click();
      else window.location.href = routes.cart || '/cart';
    }

    async function addAll() {
      if (busy) return;
      const v = currentVariant();
      const qty = currentQty();
      const chosen = items.filter((cb) => cb.checked);
      const lines = [];
      if (v && v.available) lines.push({ id: v.id, quantity: qty });
      chosen.forEach((cb) => lines.push({ id: Number(cb.value), quantity: 1 }));
      if (!lines.length) return;

      busy = true;
      hideError();
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      addBtn.setAttribute('aria-busy', 'true');
      if (addLabel) addLabel.textContent = CT.btnBusy;
      try {
        const res = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lines }),
        });
        let data = null;
        try { data = await res.json(); } catch (e) { /* keine JSON-Antwort */ }
        if (!res.ok) {
          const err = new Error((data && (data.description || data.message)) || '');
          err.status = res.status;
          throw err;
        }
        if (v && v.available) state.pendingAdd = { id: v.id, qty };
        items.forEach((cb) => { cb.checked = false; });
        busy = false;
        let refreshed = false;
        try { refreshed = await refreshDrawer(); } catch (e) { refreshed = false; }
        if (refreshed) openDrawer();
        else window.location.href = routes.cart || '/cart';
      } catch (err) {
        if (err && err.status === 429) showError(CT.errorBusy);
        else if (err && err.status) showError(err.message || CT.error);
        else showError(CT.errorNetwork);
      } finally {
        busy = false;
        addBtn.classList.remove('is-loading');
        addBtn.removeAttribute('aria-busy');
        renderCross(currentVariant());
      }
    }

    renderAll();
  }

  const init = (scope) => {
    const roots = scope && scope.matches && scope.matches('[data-product]') ? [scope] : $$('[data-product]', scope || document);
    roots.forEach(initCommerce);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
